import type { SelectFieldOption } from "@adrekic/fieldsjson"
import { Menu, type MenuMultiSelectGroupProps } from "@overmap-ai/blocks"
import { normalizeFieldOptions } from "@overmap-ai/forms"
import { memo, useMemo } from "react"

import { MultiSelectItemTemplate, SelectAllItemTemplate } from "../MenuGroups/constants"

export interface SelectFieldOptionMultiSelectGroupProps extends MenuMultiSelectGroupProps<string> {
	selectFieldOptions: SelectFieldOption[]
}

export const SelectFieldOptionMultiSelectGroup = memo<SelectFieldOptionMultiSelectGroupProps>((props) => {
	const { ref, selectFieldOptions, ...rest } = props

	const normalizedOptions = useMemo(() => normalizeFieldOptions(selectFieldOptions), [selectFieldOptions])

	return (
		<Menu.MultiSelectGroup<string> ref={ref} {...rest}>
			<SelectAllItemTemplate>Select all</SelectAllItemTemplate>
			{normalizedOptions.map((selectFieldOption) => (
				<MultiSelectItemTemplate<string> key={selectFieldOption.value} value={selectFieldOption.value}>
					<span className="truncate">{selectFieldOption.label}</span>
				</MultiSelectItemTemplate>
			))}
		</Menu.MultiSelectGroup>
	)
})
SelectFieldOptionMultiSelectGroup.displayName = "SelectFieldOptionMultiSelectGroup"
